/**
 * Stinger Commander grants two Stingers in one attack. Coalesce them into a single
 * batched fly session so the player sees one attack-triggered animation, not two
 * (or three when combined with duplicate detector replay).
 */
export function coalesceHandOrderGrantFlyBatch(grants) {
  if (!grants?.length) {
    return [];
  }

  const passthrough = [];
  const stingerGroups = new Map();

  grants.forEach((grant) => {
    if (grant?.source !== 'stinger_commander' || !grant?.key) {
      passthrough.push(grant);
      return;
    }
    const keyParts = String(grant.key).split(':');
    if (keyParts.length < 3) {
      throw new Error(`coalesceHandOrderGrantFlyBatch: invalid grant key ${grant.key}`);
    }
    const providerInstanceId = keyParts[1];
    const groupKey = `${providerInstanceId}:${grant.zone}:${grant.index}`;
    if (!stingerGroups.has(groupKey)) {
      stingerGroups.set(groupKey, []);
    }
    stingerGroups.get(groupKey).push(grant);
  });

  stingerGroups.forEach((group) => {
    if (group.length === 1) {
      passthrough.push(group[0]);
      return;
    }
    const providerInstanceId = String(group[0].key).split(':')[1];
    const batchOrderInstanceIds = group.map((g) => String(g.orderInstanceId));
    passthrough.push({
      ...group[0],
      key: `hand-grant-batch:${providerInstanceId}:${batchOrderInstanceIds.join('_')}`,
      batchGrants: group,
      batchOrderInstanceIds,
    });
  });

  return passthrough;
}
